module.exports = __webpack_public_path__ + "static/3.3_Hand_Heart_Icon-01-45f153c54374129db0a492b3f62fa850.png";